import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Wave UI-1: the canonical class-merger.
 *
 * Previously `cn` was a simple Boolean-filter join, which could not
 * resolve Tailwind conflicts. Now: clsx normalizes the input (strings,
 * objects, arrays, booleans) and tailwind-merge resolves duplicate
 * utility families so a caller's `className` actually wins over the
 * variant's defaults. This is the foundation that lets primitives
 * accept className overrides safely.
 *
 * The signature accepts the same shape as before (strings + booleans),
 * plus everything clsx supports (objects, nested arrays). Existing
 * call sites stay backward compatible.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

// Shared affordance for editor preview tap targets. Hover ring only when
// in edit mode; public profile renders without this class so visitors see
// no edit affordances.
export const EDIT_AFFORDANCE_CLASS =
  'cursor-pointer transition hover:ring-2 hover:ring-primary/40 hover:ring-inset focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-inset'
